import { Button, ButtonProps } from '@lfg/ui/components';

import { colors } from 'src/global/styles/colors';

export function PrimaryButton({ children, sx, ...rest }: ButtonProps) {
  return (
    <Button
      variant='contained'
      bgColor={colors.brand300}
      borderRadius={'4px'}
      sx={{
        padding: '14px 32px',
        display: 'flex !important',
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        '&:disabled': {
          color: colors.neutral200,
        },
        '&:hover': {
          backgroundColor: colors.brand200,
        },
        ...sx,
      }}
      fullWidth
      {...rest}>
      {children}
    </Button>
  );
}
